import { Box, Typography } from '@mui/material';

type InfoRowProps = {
  title: string;
  content: string;
  titleId?: string;
};

export const InfoRow = (props: InfoRowProps): JSX.Element => {
  const { title, content, titleId } = props;
  return (
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ width: 96 }}>
        <Typography
          variant="h4"
          color="textSecondary"
          id={titleId}
          sx={(theme) => ({ fontSize: theme.typography.body2.fontSize })}
        >
          {title}
        </Typography>
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography variant="body2">{content}</Typography>
      </Box>
    </Box>
  );
};
